declare const jQuery: JQueryStatic;
const $ = jQuery;

import * as classnames from "classnames";

function popupShouldCloseOthers($popup): boolean {
	return $popup.is("[data-popup-close-others]");
}

function initPopups($popups: JQuery): void {
	$popups.on("open", function popupOpen(event, data) {
		showPopup($(this), data);
	}).on("close", function popupClose() {
		hidePopup($(this));
	});
	$popups.find(`[data-popup-close]`).on("click", function (ev) {
		const $popup = $(this).closest(`[data-popup]`);
		hidePopup($popup);
	});
	$popups.filter(`[data-auto-open-delay]`).each(function () {
		const $popup = $(this);
		const delayMSecs: number = (parseInt($popup.attr("data-auto-open-delay") || '', 10) || 0) * 1000;
		setTimeout(function () {
			showPopup($popup);
		}, delayMSecs);
	});
	// Prevent internal items' 'open' & 'close' events causing unexpected behaviour
	$popups.children().on("open close", function (event) {
		event.stopPropagation();
	});
}

function closeOtherPopups($popup: JQuery): void {
	$(`[data-popup]`).not($popup).each(function () {
		hidePopup($(this));
	});
}

function closeAllPopups(): void {
	$(`[data-popup]`).each(function () {
		hidePopup($(this));
	});
}

function anyPopupsOpen(): boolean {
	return $(`[data-popup].show`).length > 0;
}

function showPopup($popup: JQuery, popupData?: any): void {
	if ($popup.length === 0) {
		console.error(`showPopup passed empty JQuery $popup`);
		return;
	}
	if (popupShouldCloseOthers($popup)) {
		const delay: number = $popup.is("[data-popup-close-others-delay]") ? 800 : 0;
		setTimeout(() => {
			closeOtherPopups($popup);
		}, delay);
	}
	const display: string = $popup.attr("data-css-display") || "block";
	$popup.css({ display }).removeClass("too-tall").trigger("opening", { popupData });
	const $inner = $popup.find(".popup-main").children();
	setTimeout(function () {
		$popup.addClass("show");
		if (($inner.outerHeight() || 0) >= ($popup.outerHeight() || 0)) {
			$popup.addClass("too-tall");
		}
		$popup.find("[autofocus]").first().trigger('focus');
		const popupId: string = $popup.attr("data-popup") || '';
		$(document.body).addClass(`popup-open popup-open-${popupId}`);
		$popup.trigger("opened", { popupData });
	}, 40);
}

function hidePopup($popup: JQuery): void {
	if (!$popup.hasClass("show")) {
		return;
	}
	$popup.trigger("closing").removeClass("show").removeClass("too-tall");
	const popupId: string = $popup.attr("data-popup") || '';
	$(document.body).removeClass(`popup-open popup-open-${popupId}`);
	setTimeout(function () {
		$popup.css({ display: "none" }).trigger("closed");
		if ($popup.is('[data-popup-remove-on-close]')) {
			$popup.remove();
		}
	}, 650);
}

export function hideAllPopups(): void {
	$(`[data-popup]`).each(function () {
		hidePopup($(this));
	});
}

export interface DynamicPopupSettings {
	content: HTMLElement | JQuery | string; // HTML fragment or DOM element
	parent?: HTMLElement | JQuery;
	popupId?: string;
	className?: string | string[];
	heading?: string;
	putCloseBtn?: boolean; // default true
	autoOpenDelay?: number; // milliseconds before auto-open
	closeOthersOnOpen?: boolean; // whether to close other popups on open (default false)
	openImmediately?: boolean; // whether to open the popup upon creation (default false)
	removeOnClose?: boolean; // whether to remove the popup from the DOM upon close (default false)
	cssDisplay?: 'block' | 'flex' | 'grid';
}

// Creates a new popup on the fly and appends it to <body>.
// Returns jQuery for popup.
// To open/close it, fire open/close events on the returned jQuery object.
export function createDynamicPopup(settings: DynamicPopupSettings) {
	const popupId: string = settings.popupId || getDynamicPopupId();
	const $popup = $(`<div>`).attr("data-popup", popupId);
	if (settings.autoOpenDelay) {
		$popup.attr("data-auto-open-delay", settings.autoOpenDelay);
	}
	if (settings.closeOthersOnOpen) {
		$popup.attr("data-popup-close-others", "");
	}
	if (settings.cssDisplay) {
		$popup.attr("data-css-display", settings.cssDisplay);
	}
	$popup.addClass(classnames("popup", `popup-${popupId}`, settings.className));
	const $main = $(`<div class="popup-main">`).appendTo($popup);
	const $mainInner = $(`<div>`).appendTo($main);
	if (settings.heading) {
		$mainInner.append(`<header><h2>${settings.heading}</h2></header>`);
	}
	const $content = $(`<div class="popup-content">`).append(settings.content);
	$mainInner.append($content);
	if (settings.putCloseBtn || settings.putCloseBtn === undefined) {
		$popup.append(`<div class="popup-close-wrap"><div class="popup-close" data-popup-close=""></div></div>`);
	}
	$(settings.parent || document.body).append($popup);
	initPopups($popup);
	if (settings.removeOnClose) {
		$popup.attr('data-popup-remove-on-close', '');
	}
	if (settings.openImmediately) {
		$popup.trigger("open");
	}
	return $popup;
}

let dynamicPopupIdCounter = 0;
function getDynamicPopupId(): string {
	++dynamicPopupIdCounter;
	return `popup_` + dynamicPopupIdCounter;
}
